<template>
   <div>
   <v-dialog name="editRow" v-model="level.dialogValues.dialogShow.ldap" data-app="true" persistent max-width="900">
      <v-card>

       <CardUpdatableHeader :row="row" :level="level"/>

        <v-card-text>
          <v-container>
            <h4>{{ $t('subtitles.settings') }}</h4>

            <v-row v-if="PLFdialogOptions.plf_is_dynamic">
              <v-col cols="12">
                <v-text-field v-model="row.xxx_dyn_connector_name" :disabled="level.dialogValues.form_disabled" :label="$t('texts.xxx_dyn_connector_name')" :rules="level.dialogOptions.codeRules" :hint="$t('hints.xxx_dyn_connector_name')" :persistent-hint="level.dialogValues.form_create">
                </v-text-field>
              </v-col>
            </v-row>

            <v-row v-if="PLFdialogOptions.plf_is_auth" no-gutters>
              <v-col cols="12">
                 <h5>{{ $t('subtitles.ldc_section_ou') }}</h5>
              </v-col>
              <v-col cols="12" sm="8" md="8">
                <v-text-field v-model="row.xxx_ad_org_unit" :disabled="level.dialogValues.form_disabled" outlined :label="$t('texts._xxx_ad_org_unit')" :rules="level.dialogOptions.codeRules" required :hint="$t('hints.xxx_ad_org_unit')" :persistent-hint="level.dialogValues.form_create">
                </v-text-field>
              </v-col>
            </v-row>

            <v-row v-if="PLFdialogOptions.plf_is_auth && PLFdialogOptions.plf_is_dynamic" no-gutters>
              <v-col cols="12">
                 <h5>{{ $t('subtitles.ldc_section_dynamic') }}</h5>
              </v-col>
              <v-col cols="12" sm="6">
                <v-text-field v-model="row.xxx_dyn_ldap_uri" :disabled="level.dialogValues.form_disabled" :label="$t('texts._xxx_dyn_ldap_uri')" :rules="level.dialogOptions.codeRules" required :hint="$t('hints.xxx_dyn_ldap_uri')" :persistent-hint="level.dialogValues.form_create">
                </v-text-field>
              </v-col>

              <v-col cols="12" sm="6">
                <v-text-field v-model="row.xxx_dyn_ldap_basedn" :disabled="level.dialogValues.form_disabled" :label="$t('texts._xxx_dyn_ldap_basedn')" :rules="level.dialogOptions.codeRules" required :hint="$t('hints.xxx_dyn_ldap_basedn')" :persistent-hint="level.dialogValues.form_create">
                </v-text-field>
              </v-col>

              <v-col cols="12" sm="6">
                <v-text-field v-model="row.xxx_dyn_ldap_bind_login" :disabled="level.dialogValues.form_disabled" :label="$t('texts._xxx_dyn_ldap_bind_login')" :rules="level.dialogOptions.codeRules" required :hint="$t('hints.xxx_dyn_ldap_bind_login')" :persistent-hint="level.dialogValues.form_create">
                </v-text-field>
              </v-col>

              <v-col cols="12" sm="6">
                <v-text-field
                  v-model="row.xxx_dyn_ldap_bind_password"
                  :disabled="level.dialogValues.form_disabled"
                  :label="$t('texts._xxx_dyn_ldap_bind_password')"
                  :rules="level.dialogOptions.codeRules"
                  required
                  :hint="$t('hints.xxx_dyn_ldap_bind_password')" 
                  :persistent-hint="level.dialogValues.form_create"
                  name="xxx_dyn_ldap_bind_password"
                  :type="showBindPassword ? 'text' : 'password'"
                  :append-icon="showBindPassword ? 'mdi-eye' : 'mdi-eye-off'"
                  @click:append="showBindPassword = !showBindPassword"
               >
                </v-text-field>
              </v-col>
            </v-row>

            <v-row v-if="PLFdialogOptions.plf_is_auth && !PLFdialogOptions.plf_is_dynamic" no-gutters>
              <v-col cols="12">
                 <h5>{{ $t('subtitles.ldc_section_auth') }}</h5>
              </v-col>

              <v-col cols="12" sm="6">
                <v-text-field v-model="row.plf_ws_url_base" disabled :label="$t('texts.plf_ws_url_base')" />
              </v-col>

              <v-col cols="12" sm="6">
                <v-text-field v-model="row.plf_domain_radix" disabled :label="$t('texts.plf_domain_radix')" />
              </v-col>
            </v-row>

            <div v-if="showMPRzone">

            <h5>{{ $t('subtitles.inform_by_mail') }}</h5>
            <v-row no-gutters>
               <v-col cols="12" sm="6">
                  <v-select
                     :items="items_warn_levels"
                     items-disabled="disabled"
                     type="number"
                     :value="row.xxx_inform_warn_level"
                     :disabled="level.dialogValues.form_delete"
                     :label="$t('texts.xxx_inform_warn_level')"
                     v-on:change="change_warnlevel"
                  >
                  </v-select>
               </v-col>
            </v-row>

            <h5>{{ $t('subtitles.inform_to_customer') }} :</h5>
            <v-row no-gutters>
               <v-col cols="12" sm="6">
                  <v-text-field dense v-model="row.xxx_inform_to_emails" maxlength="400" :disabled="level.dialogValues.form_disabled" :label="$t('texts.xxx_inform_to_emails')" :hint="$t('hints.xxx_inform_to_emails')"></v-text-field>
               </v-col>
               <v-col cols="12" sm="6">
                 <ddoSelectMailprofile :callbacks="MPRTOcallbacks" ref="mySelectMPRTO" :disabled="row.xxx_inform_to_emails==null" :options="MPRTOoptions"/>
               </v-col>
            </v-row>
            <h5>{{ $t('subtitles.inform_to_manager') }} :</h5>
            <v-row>
               <v-col cols="12" sm="6">
                  <v-text-field dense v-model="row.xxx_inform_cc_emails" maxlength="400" :disabled="level.dialogValues.form_disabled" :label="$t('texts.xxx_inform_cc_emails')" :hint="$t('hints.xxx_inform_cc_emails')"></v-text-field>
               </v-col>
               <v-col cols="12" sm="6">
                 <ddoSelectMailprofile :callbacks="MPRCCcallbacks" ref="mySelectMPRCC" :options="MPRCCoptions"/>
               </v-col>
            </v-row>

            </div>

            <v-row>
              <v-col v-if="!level.dialogValues.form_create" cols="auto">
                <b-badge class="m-1" variant="info">{{ $t('headers.created_on') }}</b-badge>{{ $api._d(row.xxx_create,'long') }}<br/>
                <b-badge class="m-1" variant="info">{{ $t('headers.updated_on') }}</b-badge>{{ $api._d(row.xxx_create,'long') }}
              </v-col>
            </v-row>

         </v-container>
          <small>*{{ $t('texts.requiredfield') }}</small>
        </v-card-text>

        <CardUpdatableFooter :row="row" :level="level"/>

      </v-card>
   </v-dialog>
   </div>
</template>

<script>
import i18n from '@/plugins/i18n.js';
import ddoAlert from '@/components/ddoAlert.vue';
import CardUpdatable from '@/components/partials/CardUpdatable.vue';
import CardUpdatableHeader from '@/components/partials/CardUpdatableHeader.vue';
import CardUpdatableFooter from '@/components/partials/CardUpdatableFooter.vue';
import CardUpdatableFooterConfirm from '@/components/partials/CardUpdatableFooterConfirm.vue';
import ddoSelect from '@/components/ddoSelect.vue';
import ddoSelectMailprofile from '@/components/ddoSelectMailprofile.vue';

export default {
   name: 'CardUpdatableCUSPLFLDAP',
   extends: CardUpdatable,
   components: {
      ddoAlert,
      CardUpdatableHeader,
      CardUpdatableFooter,
      ddoSelect,
      ddoSelectMailprofile,
   },

   props: {
   },

   data: function () {
      return {
         show_pwd: false,
         current_usercount: null,
         _pk_to_add: 0,
         editWarning: false,
         isActive: false,

         showMPRzone: false,

         showBindPassword: false,

         PLFcallbacks: {},
         PLFoptions: {
            initial: null,
            required: true,
            disabled: true,
            multiple: false,
            clearable: false,
            item_text: "plf_name",
            item_value: "plf_pk",
            item_disabled: "",
            hide_selected: true,
            label: i18n.t('texts.platform'),
         },
         PLFdialogOptions: {
            cus_code: null,
            cus_name: null,
            plf_is_auth: false,
            plf_is_dynamic: false,
            plf_exchangelike: false,
            plf_citrixlike: false,
            plf_ws_url_base: null,
            plf_domain_radix: null,
         },

         MPRTOcallbacks: {},
         MPRTOoptions: {
            initial: null,
            required: true,
            disabled: false,
            multiple: false,
            clearable: false,
            item_text: "mpr_name",
            item_value: "mpr_pk",
            item_disabled: "",
            hide_selected: true,
            label: i18n.t('texts.xxx_mailprofile_to'),
        },

         MPRCCcallbacks: {},
         MPRCCoptions: {
            initial: null,
            required: true,
            disabled: false,
            multiple: false,
            clearable: false,
            item_text: "mpr_name",
            item_value: "mpr_pk",
            item_disabled: "",
            hide_selected: true,
            label: i18n.t('texts.xxx_mailprofile_cc'),
        },

         callbacks: {
         },

         options: {
            initial: [],
            disabled: false,
            multiple: true,
            clearable: false,
            item_text: "username",
            item_value: "username",
            item_disabled: "",
            hide_selected: true,
            switch_myself: false,
         },

         items_warn_levels: [ { value: 0, text: i18n.t('texts.level_ok') }, { value: 1, text: i18n.t('texts.level_warning') }, { value: 2, text: i18n.t('texts.level_error') }  ],

      }
   },

   created() {
      this.MPRTOcallbacks.refresh_rows = this.build_select_mpr;
      this.MPRTOcallbacks.change = this.change_mpr_to;
      this.MPRCCcallbacks.refresh_rows = this.build_select_mpr;
      this.MPRCCcallbacks.change = this.change_mpr_cc;
   },

   mounted() {
      this.options.disabled = this.level.dialogValues.form_delete;

      if ( this.level.row!=null) {
         this.PLFdialogOptions.plf_name         = this.level.row.plf_name;
         this.PLFdialogOptions.plf_is_auth      = this.level.row.plf_is_auth;
         this.PLFdialogOptions.plf_is_dynamic   = this.level.row.plf_is_dynamic;
         this.PLFdialogOptions.plf_exchangelike = (this.level.row.plf_exchangelike==1 ? true : false);
         this.PLFdialogOptions.plf_citrixlike   = ( this.level.row.plf_citrixlike==1 ? true : false);
         this.PLFdialogOptions.plf_smtplike     = ( this.level.row.plf_smtplike==1 ? true : false);
         this.PLFdialogOptions.plf_ws_url_base  = this.level.row.plf_ws_url_base;
         this.PLFdialogOptions.plf_domain_radix = this.level.row.plf_domain_radix;
         console.log('In CardUpdatableCUSPLFLDAP.change, PLFdialogOptions='+JSON.stringify(this.PLFdialogOptions));
         console.log('In CardUpdatableCUSPLFLDAP.change, row='+JSON.stringify(this.level.row));
      } else {
      console.log('In CardUpdatableCUSPLFLDAP.form, change plf select, NO CHANGE!, value='+value);
      }

      if ( this.$refs.mySelectMPRTO ) {
         this.$refs.mySelectMPRTO.refresh_rows();
      }
      if ( this.$refs.mySelectMPRCC ) {
         this.$refs.mySelectMPRCC.refresh_rows();
      }
      
      if ( this.level.row.mpr_pk!=null ) {
         this.MPRTOoptions.initial = this.level.row.mpr_pk;
      }
      if ( this.level.row.mpr_pk_cc!=null ) {
         this.MPRCCoptions.initial = this.level.row.mpr_pk_cc;
      }
   },

   methods: {

      async build_select_mpr(key=null) {
         this.loading = true;
         var { errorinfos, api_response } = await this.$api.getRows(this.$router,'mailprofile');
         this.loading = false;
         return { errorinfos, api_response }
      },
      async change_mpr_to(value,item=null) {
         if ( item!=null) {
            this.level.row.mpr_pk = item.mpr_pk;
         } else {
           this.level.row.mpr_pk = null;
         }
      },
      async change_mpr_cc(value,item=null) {
         if ( item!=null) {
            this.level.row.mpr_pk_cc = item.mpr_pk;
         } else {
           this.level.row.mpr_pk_cc = null;
         }
      },
      async change_active(value) {
         if ( value ) { this.level.row.xxx_active=1; } else { this.level.row.xxx_active=0; }
      },

      change_warnlevel(value) {
         this.row.xxx_inform_warn_level = value;
      },

      buid_html_table(array,withpassword=true) {
         var result = '';
         if ( array.length>0 ) {
            if ( withpassword ) {
               result += '<table border=1><tr><th>Username</th><th>Password</th></tr>';
            } else {
               result += '<table border=1><tr><th>Username</th></tr>';
            }
            for ( var i=0;i<array.length;i++ ) {
               if ( withpassword ) {
                  result += '<td>'+array[i].username+'</td><td>'+array[i].password+'</td></tr>';
               } else {
                  result += '<td>'+array[i].username+'</td><td></tr>';
               }
            }
            result += '</table>';
         }
         return result;
      },

   }
}
</script>